import { flash_msg } from './flash_msg'
import { alert } from './alert'
import { ec_apply_cart } from './ec-apply-cart'
export const Odin = { flash_msg, alert, ec_apply_cart }
export const Odim = { flash_msg, alert, ec_apply_cart }
